import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { UsersThree, Plus, X } from "@phosphor-icons/react";

/** Manage the app-wide list of sous-équipes (Dépannage, Tirage, Tableautier…). */
export default function TeamsConfigCard() {
  const [teams, setTeams] = useState([]);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  const load = async () => {
    try { const r = await api.get("/teams"); setTeams(r.data.teams || []); }
    catch (err) { console.warn("teams load failed:", err); }
  };

  const commit = async (next) => {
    setSaving(true);
    try {
      const r = await api.patch("/admin/teams", { teams: next });
      setTeams(r.data.teams || []);
      toast.success("Sous-équipes enregistrées");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  const add = () => {
    const t = draft.trim();
    if (!t) return;
    if (teams.includes(t)) { toast.error("Sous-équipe déjà existante"); return; }
    setDraft("");
    commit([...teams, t]);
  };

  const remove = (t) => {
    if (!window.confirm(`Retirer la sous-équipe "${t}" ? Les techniciens ne seront pas supprimés, seulement dissociés.`)) return;
    commit(teams.filter((x) => x !== t));
  };

  return (
    <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-3 space-y-3" data-testid="teams-config-card">
      <div className="flex items-center gap-2">
        <UsersThree size={16} className="text-[#005CFF]" weight="duotone" />
        <div className="text-sm font-semibold">Sous-équipes</div>
      </div>
      <div className="text-[10px] text-white/50">
        Regroupe tes techniciens par métier pour filtrer le planning (ex: Dépannage, Tirage, Tableautier).
      </div>

      <div className="flex flex-wrap gap-1.5">
        {teams.length === 0 && <span className="text-xs text-white/40">Aucune sous-équipe</span>}
        {teams.map((t) => (
          <div key={t} className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#005CFF]/15 border border-[#005CFF]/30 text-xs" data-testid={`team-chip-${t}`}>
            <span>{t}</span>
            <button onClick={() => remove(t)} disabled={saving} className="text-white/40 hover:text-red-400 -mr-1">
              <X size={11} weight="bold" />
            </button>
          </div>
        ))}
      </div>

      <div className="flex gap-1.5">
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Ajouter une sous-équipe…"
          className="flex-1 bg-white/5 border-white/10 h-9 text-xs"
          data-testid="team-add-input"
        />
        <Button onClick={add} disabled={saving || !draft.trim()} className="bg-[#005CFF] hover:bg-[#0047CC] h-9 px-3" data-testid="team-add-btn">
          <Plus size={13} weight="bold" />
        </Button>
      </div>
    </div>
  );
}
